// @ts-ignore
import type * as SchemaTypes from '../../index';

import { gql } from 'graphql-tag';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateDiamondSearchProductEnquiryExistingCustomerDocument = gql`
    mutation createDiamondSearchProductEnquiryExistingCustomer($input: EnquiryDiamondSearchProduct!) {
  createEnquiryDiamondSearchProductExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useCreateDiamondSearchProductEnquiryExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateDiamondSearchProductEnquiryExistingCustomerMutation, SchemaTypes.CreateDiamondSearchProductEnquiryExistingCustomerMutationVariables>(CreateDiamondSearchProductEnquiryExistingCustomerDocument);
};